import { Component, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { MatTableDataSource, MatPaginator, MatSort, MatStepper, MatSnackBar } from '@angular/material';
import { SelectionModel } from '@angular/cdk/collections';
import { ManagePackagesDataSource } from '../../../core/packages/_data-sources/manage-packages.datasource';
import { PackagesHttpService } from '../../../core/packages';
import { tap } from 'rxjs/operators';
import { Directive, HostListener } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { merge } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { BulkHttpService } from '../../../core/bulk';
import { Cache } from 'aws-amplify';
import * as XLSX from 'xlsx';
import { timer } from 'rxjs';
import { MixpanelService } from '../../../services/mixpanel.service';
import { FilterParams } from '../../../core/filter-options/filter-options.service';
import { SelectOption } from '../../partials/content/general/searchable-select/searchable-select.component';

export interface MachineStr {
	machine_id: string;
	machine_name: string;
	position: number;
	aux_cv: number;
	ui: number;
}


@Component({
  selector: 'kt-bulk-actions',
  templateUrl: './bulk-actions.component.html',
  styleUrls: ['./bulk-actions.component.scss']
})


export class BulkActionsComponent implements OnInit, AfterViewInit {
//   displayedColumns: string[] = ['select', 'machine_id', 'machine_name', 'ui_cv', 'aux_cv', 'menu_cv'];
  dataSource = new MatTableDataSource<MachineStr>();
  fileName = "Version Report"
  selection = new SelectionModel<MachineStr>(true, []);
//   availableColumns: string[] = [ 'ui_cv','ui_av', 'aux_cv', 'aux_av', 'menu_cv', 'menu_av'];
displayedColumns: string[] = ['select', 'machine_id', 'machine_name', 'ui_cv', 'aux_cv', 'menu_cv'];
availableColumns = [{value: 'ui_cv', key: 'UI (current version)'}, {value: 'aux_cv', key: 'VMC (current version)'},
  {value: 'menu_cv', key: 'MENU (current version)'},{value: 'ui_av', key: 'UI (available version)'},
  {value: 'aux_av', key: 'VMC (available version)'}, {value: 'menu_av', key: 'MENU (available version)'}];


  showSettingsPanel: boolean = false;
  columnVisibility: { [key: string]: boolean } = {
	'ui_cv': true,
  	'aux_cv': true,
  	'menu_cv': true
  };


toggleColumnVisibility(column: any): void {
	const columnObject = this.availableColumns.find(col => col.key === column.key);
	if (columnObject && columnObject.value !== 'machine_id' && columnObject.value !== 'machine_name') {
	  this.columnVisibility[columnObject.value] = !this.columnVisibility[columnObject.value];
	  this.refreshDisplayedColumns();
	}
}


refreshDisplayedColumns(): void {
const fixedColumns = ['select', 'machine_id', 'machine_name'];
const selectedColumns: string[] = [];
for (const col of this.availableColumns) {
	if (this.columnVisibility[col.value]) {
	selectedColumns.push(col.value);
	}
}
this.displayedColumns = fixedColumns.concat(selectedColumns);
}



// refreshDisplayedColumns(): void {
// 	const fixedColumns = ['select','machine_id', 'machine_name'];
// 	const selectedColumns: string[] = [];
// 	for (const col of this.availableColumns) {
// 	  if (this.columnVisibility[col]) {
// 		selectedColumns.push(col);
// 	  }
// 	}
// 	this.displayedColumns = fixedColumns.concat(selectedColumns);
// 	// console.log('Displayed columns after refresh:', this.displayedColumns);
//     // console.log('Column visibility object:', this.columnVisibility);
//     this.cdr.detectChanges();
//   }

  opt;

  selectedMacs = [];

  constructor(private http: BulkHttpService, private cdr: ChangeDetectorRef, private _snackBar: MatSnackBar,
	private activatedRoute: ActivatedRoute, private router: Router,
	private mixpanelService: MixpanelService) { }

  regions;
  selRegion = '';
  territories;
  selTerritory = '';
  versionTypes = [{value: 'ui_cv', key: 'UI (current version)'}, {value: 'aux_cv', key: 'VMC (current version)'},
  {value: 'menu_cv', key: 'MENU (current version)'},{value: 'ui_av', key: 'UI (available version)'},
  {value: 'aux_av', key: 'VMC (available version)'}, {value: 'menu_av', key: 'MENU (available version)'}];
  versionTypeOptions: SelectOption[] = [
    { value: '', label: 'All' },
    { value: 'ui_cv', label: 'UI (current version)' },
    { value: 'aux_cv', label: 'VMC (current version)' },
    { value: 'menu_cv', label: 'MENU (current version)' },
    { value: 'ui_av', label: 'UI (available version)' },
    { value: 'aux_av', label: 'VMC (available version)' },
    { value: 'menu_av', label: 'MENU (available version)' }
  ];
  selType: string | number | null = null;
  versions;
//   versions: any[] = [];
  versionOptions: SelectOption[] = [{ value: '', label: 'All' }];
  selVersion: string | number | null = null;
  actionOptions: SelectOption[] = [
    { value: 'update', label: 'S/W & F/W Updates' }
  ];
  machines;

  selected = 1;
  user;
  role;
  macType;
  selectedDisti = {disti_id: null};
	selectedClient = {client_id: null};
	selectedCampus = {campus_id: null};
	selectedMarket = {market_id: null};
	distiName = 'ALL';
	clientName = 'ALL';
	campusName = 'ALL';
	marketName = 'ALL';

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  @ViewChild(MatSort, {static: false}) sort: MatSort;

  qParams = {};

  private defaultParams = {
	noPerPg: 50,
	pgNo: 0,
	sortKey: 'serial_no',
	sortVal: 'asc',
	registered: true,
	optFilterKey: 'connectivity',
	optFilterVal: '',
	optFilterKey1: 'machine_status',
	optFilterVal1: '',
	txtFilterKey: 'location_name',
	txtFilterVal: '',
	disti_id: null,
	client_id: null,
	campus_id: null,

};

  ngOnInit() {
	//   this.getRegions();
	this.user = Cache.getItem('userAttr');
	this.role = this.user['custom:role'];
	if(this.user['custom:disti_id'])
		this.selectedDisti = {disti_id: this.user['custom:disti_id']}
	if(this.user['custom:client_id'])
		this.selectedClient = {client_id: this.user['custom:client_id']}
	if(this.user['custom:campus_id'])
		this.selectedCampus = {campus_id: this.user['custom:campus_id']}

	this.dataSource.paginator = this.paginator;
	this.getMachines();

	this.mixpanelService.track(this.mixpanelService.PAGE_VIEW);
  }

  ngAfterViewInit() {
	this.activatedRoute.queryParams.subscribe(params => {
		if (params.reset) {
			// console.log(params);
			this.selection.clear();
			this.selectedMacs = [];
			this.router.navigate([], {queryParams: {}});
		} else {

		}
	});

	// if (this.activatedRoute.snapshot.paramMap.get('reset')) {
	// 	console.log(`this.activatedRoute.snapshot.paramMap.get('reset')`, this.activatedRoute.snapshot.paramMap.get('reset'));
	// 	this.selection.clear();
	// 	this.selectedMacs = [];
	// }

	console.log(this.router.url.search('reset'));
  }

  getMachines() {
	const selTypeValue = this.selType || '';
	const selVersionValue = this.selVersion || '';

	this.qParams = {
		noPerPg: this.paginator.pageSize || 50,
		pgNo: this.paginator.pageIndex || 0,
		sortKey: 'serial_no',
		sortVal: 'asc',
		registered: true,
		disti_id: this.selectedDisti ? this.selectedDisti.disti_id : null,
		client_id: this.selectedClient ? this.selectedClient.client_id : null,
		campus_id: this.selectedCampus ? this.selectedCampus.campus_id : null,
		market_id: this.selectedMarket ? this.selectedMarket.market_id : null,
		type: selTypeValue,
		version: selVersionValue
	};

	  this.http.getAllVersions(this.qParams)
	  .subscribe((machines: any[]) => {
		// console.log(machines);
		this.machines = machines;
		this.dataSource.data = machines;

		console.log("Length:",this.dataSource.data.length);
		// console.log("Datasource: ", this.dataSource);

		this.cdr.detectChanges();
	  });
  }

  onFiltersChange(params: FilterParams): void {
		// Update selected entities from FilterParams
		const previousDistiId = this.selectedDisti ? this.selectedDisti.disti_id : null;

		if (params.disti_id) {
			const distiId = Array.isArray(params.disti_id) ? params.disti_id[0] : params.disti_id;
			this.selectedDisti = { disti_id: distiId };
			this.distiName = 'Selected'; // The hierarchical-filters component handles display

			// Reset dependent selections if distributor changed
			if (previousDistiId !== distiId) {
				this.selectedMarket = { market_id: null };
				this.marketName = 'ALL';
				this.selectedClient = { client_id: null };
				this.clientName = 'ALL';
				this.selectedCampus = { campus_id: null };
				this.campusName = 'ALL';
			}
		} else {
			this.selectedDisti = { disti_id: null };
			this.distiName = 'ALL';
		}

		if (params.market_id) {
			const marketId = Array.isArray(params.market_id) ? params.market_id[0] : params.market_id;
			this.selectedMarket = { market_id: marketId };
			this.marketName = 'Selected';
		} else {
			this.selectedMarket = { market_id: null };
			this.marketName = 'ALL';
		}

		if (params.client_id) {
			const clientId = Array.isArray(params.client_id) ? params.client_id[0] : params.client_id;
			this.selectedClient = { client_id: clientId };
			this.clientName = 'Selected';

			// Reset campus if client changed
			if (!params.campus_id) {
				this.selectedCampus = { campus_id: null };
				this.campusName = 'ALL';
			}
		} else {
			this.selectedClient = { client_id: null };
			this.clientName = 'ALL';
		}

		if (params.campus_id) {
			const campusId = Array.isArray(params.campus_id) ? params.campus_id[0] : params.campus_id;
			this.selectedCampus = { campus_id: campusId };
			this.campusName = 'Selected';
		} else {
			this.selectedCampus = { campus_id: null };
			this.campusName = 'ALL';
		}

		this.getMachines();
		this.cdr.detectChanges();
	}

  onOpt(event: string | number | null) {
	  this.opt = event || '';
  }

  getRegions() {
	this.http.getRegions()
	.subscribe(regions => {
		this.regions = regions;
	});
  }

  onType() {
	const selTypeValue = this.selType || '';
	const types = String(selTypeValue).split('_');
	this.http.getVersions({type: types[0]})
	.subscribe((versions: any) => {
		// console.log("Response:", versions);
		this.selVersion = null;
		this.versions = versions.data;
		this.versionOptions = [
			{ value: '', label: 'All' },
			...versions.data.map((v: any) => ({ value: v.file_version, label: v.file_version }))
		];
	});
	this.cdr.detectChanges();
  }

  onVersion() {
	this.cdr.detectChanges();
	this.getMachines();
  }


exportExcel(): void {
	const data = this.dataSource.data;


	const columnsToExport = ['machine_id', 'machine_name', 'ui_cv', 'ui_av', 'aux_cv', 'aux_av', 'menu_cv', 'menu_av'];


	const filteredData = data.map((item: any) => {
	  const filteredItem: any = {};
	  columnsToExport.forEach((col) => {
		filteredItem[col] = item[col];
	  });
	  return filteredItem;
	});

	// Generate worksheet
	const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(filteredData);

	// Generate workbook and add the worksheet
	const wb: XLSX.WorkBook = XLSX.utils.book_new();
	XLSX.utils.book_append_sheet(wb, ws, 'Version');

	// Save to file
	XLSX.writeFile(wb, this.fileName + '.xlsx');
  }



//   /** Whether the number of selected elements matches the total number of rows. */
//   isAllSelected() {
// 	const numSelected = this.selection.selected.length;
// 	const numRows = this.dataSource.data.length;
// 	return numSelected === numRows;
//   }

//   /** Selects all rows if they are not all selected; otherwise clear selection. */
//   masterToggle() {
// 	this.isAllSelected() ?
// 	this.selection.clear() :
// 	this.dataSource.data.forEach(row => this.selection.select(row));
//   }

//   /** The label for the checkbox on the passed row */
//   checkboxLabel(row?: MachineStr): string {
// 	  console.log(this.selection);
// 	if (!row) {
// 		return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
// 	}
// 	return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
//   }

isAllSelected($event) {
	const numSelected = this.selection.selected.length;
	const numRows = this.dataSource.data.length;
	return numSelected === numRows;
}

masterToggle($event) {
	if ($event.checked) {
		this.onCompleteRow(this.dataSource);
	}
	this.isAllSelected($event) ?
		this.selection.clear() :
	this.dataSource.data.forEach(row => this.selection.select(row));
}

private selectRow($event, dataSource) {
	// console.log($event.checked);
	if ($event.checked) {
	  this.selectedMacs.push(dataSource);
	//   this.selection.select(dataSource);
	} else {
		// this.selection.deselect(dataSource);
		const ind = this.selectedMacs.indexOf(dataSource);
		if (ind >= 0) {
			this.selectedMacs.splice(ind, 1);
		}
	}
	// console.log(this.selection.selected, this.selection.selected.length);
  }

  onCompleteRow(dataSource) {
	dataSource.data.forEach(element => {
	  console.log(element.name);
	});
  }

  onNext() {
	  console.log(this.selectedMacs);
	  if (this.selection.isEmpty()) {

	  } else {
		console.log(this.selection.selected);
	  }
	//   if(this.selection.selected)
  }

  showSnackBar(message: string, duration: number) {
	let snackRef = this._snackBar.open(message, 'close');
	if (duration > 0) {
		setTimeout(() => {
			this._snackBar.dismiss();
		}, duration);
	}

	snackRef.onAction().subscribe(() => {
		this._snackBar.dismiss();
	});
}

}
